import React from 'react';

const PointerCircle = () =>  <div className='pointer-circle' />;

export default PointerCircle;



// WEBPACK FOOTER //
// ./src/components/Picker/PointerCircle.js